import { DateHelper } from '../helpers/DateHelper';
import { MeasurementTypeEnum, MeasurementInterface, MeasurementResponse } from '../api/types';

export class Measurement implements MeasurementInterface {
  private static readonly typeToHumanStringMap: { [key: string]: string } = {
    [MeasurementTypeEnum.CREDIBILITY]: 'Geloofwaardigheid',
    [MeasurementTypeEnum.TENSION]: 'Spanning',
  };

  private static readonly typeToIconMap: { [key: string]: string } = {
    [MeasurementTypeEnum.CREDIBILITY]: 'gauge',
    [MeasurementTypeEnum.TENSION]: 'thermometer',
  };

  id: number;
  createAt: Date;
  answerAt?: Date;
  type: MeasurementTypeEnum;
  question: string;
  start: number;
  end: number;
  answer?: number;

  constructor({ id, createAt, answerAt, type, question, start, end, answer }: MeasurementInterface) {
    if (id === undefined) {
      throw new Error('Measurement instance requires an ID.');
    }
    this.id = id;
    this.createAt = createAt ? new Date(createAt) : new Date();
    if (answerAt) {
      this.answerAt = new Date(answerAt);
    }
    this.type = type;
    this.question = question;
    this.start = start;
    this.end = end;
    this.answer = answer;
  }

  static fromResponse(response: MeasurementResponse[]): Measurement[] {
    return response.map(measurement => new Measurement(measurement));
  }

  static resolveType(value: string): MeasurementTypeEnum|undefined {
    switch (value) {
      case MeasurementTypeEnum.CREDIBILITY:
        return MeasurementTypeEnum.CREDIBILITY;
      case MeasurementTypeEnum.TENSION:
        return MeasurementTypeEnum.TENSION;
      default:
        return undefined;
    }
  }

  static typeToHuman(type: MeasurementTypeEnum): string|undefined {
    return Measurement.typeToHumanStringMap[type];
  }

  get typeHuman(): string|undefined {
    return Measurement.typeToHuman(this.type);
  }

  static typeToIcon(type: MeasurementTypeEnum): string|undefined {
    return Measurement.typeToIconMap[type];
  }

  get typeIcon(): string|undefined {
    return Measurement.typeToIcon(this.type);
  }

  get answerSummery(): string {
    return `${(this.answer !== undefined && this.answer !== null) ? this.answer : '?'} / ${this.start} - ${this.end}`;
  }

  toString(): string {
    const dateCreated = this.createAt ? DateHelper.toDateTimeString(this.createAt) : '-';
    const dateAnswered = this.answerAt ? DateHelper.toDateTimeString(this.answerAt) : '-';
    const question = this.question ? this.question : '-';
    return `Aangemaakt: ${dateCreated}\n` +
      `Beantwoord: ${dateAnswered}\n` +
      `Type: ${this.typeHuman ? this.typeHuman : '[onbekend]'}\n` +
      `Stelling: ${question}\n` +
      `Antwoord: ${this.answerSummery}`;
  }
}
